<template>
    <div>
      <h1 class="title pb-2 mb-5 mt-5 pt-2 d-block">{{ Heading }}</h1>

      <div class="custom-text-thank-you-for-joining">
          <p class="text mb-5 d-none d-md-block">{{ ThanksForJoininDevice }}</p>
          <p class="text mb-5 d-block d-md-none">{{ ThanksForJoininMobile }}</p>
      </div>

      <div class="text-center" style="min-height:57px;">
        <div class="col-12 d-flex justify-content-center">
          <img v-show="showAppleButton" v-if="!isAndroidMobileBrowser" id="appleButton" ref="appleButton" src="@/assets/Add_to_Apple_Wallet_rgb_US-UK.svg" class="apple-icon mb-5" @click.prevent="getAppleCardFile"/>
          <a id="urlApple" ref="refApple"></a>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <g:savetoandroidpay v-show="showGoogleButton" v-if="!isAppleMobileBrowser && renderGoogleButton" height="50px" size="50px" v-bind:jwt="getJwt" onsuccess="googleCallback" onfailure="failureHandler"  theme="dark"></g:savetoandroidpay> 
        </div>

        <div v-if="showLoader" class="gold-spinner spinner-border" role="status" aria-label="Loading...">
            <span class="visually-hidden">Loading...</span>
        </div>
        <!--<p v-if="!showLoader">{{ cardNumber }}</p>-->
      </div>
      <p class="text pt-4">Once you’ve downloaded your digital Rewards card, you can view it in your Apple Wallet on iOS or the Google Pay app on Android. You can now use your digital Rewards card in-store to collect and redeem points and access promotional discounts.</p>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue'
    import digitalApi from '@/services/DigitalApiClient.js'
    import eventBus from '@/services/EventBus.js'
    import { useRoute } from 'vue-router'
    const route = useRoute()

    // Props
    const props = defineProps({
        ThanksForJoininDevice: String,
        ThanksForJoininMobile: String,
        cardNumber: String,
        jwtGoogle: String,
        customerName: String,
        tier: String,
        customerId: String,
        carduid: String,
        flagLog: String,
        Heading: String
    })

    // Template refs
    const refApple = ref(null)
    const appleButton = ref(null)

    // State
    const googleButtonLoaded = ref(false)

    // Computed
    const isAppleMobileBrowser = computed(() =>
        /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
    )
    const isAndroidMobileBrowser = computed(() =>
        /Android/i.test(navigator.userAgent)
    )
    const showAppleButton = computed(() => !!props.jwtGoogle)
    const renderGoogleButton = computed(() => !!props.jwtGoogle)
    const showGoogleButton = computed(() => googleButtonLoaded.value)
    const showLoader = computed(() => !props.jwtGoogle)

    const getJwt = computed(() => {
        downloadGoogle()
        return props.jwtGoogle
    })

    // Methods
    function googleCallback(message) {
        let platform = 'Browser'
        if (isAppleMobileBrowser.value) {
            platform = 'iOS Browser'
        } else if (isAndroidMobileBrowser.value) {
            platform = 'Android Browser'
        }
        platform = platform + ': google btn ' + props.flagLog
        digitalApi.cardDownloadLog(
            props.cardNumber,
            platform,
            navigator.userAgent,
            message.walletObjectIds[0],
            getOatParam('AccessKey'),
            getOatParam('c')
        )
    }

    function logAppleButtonDownload() {
        let platform = 'Browser'
        if (isAppleMobileBrowser.value) {
            platform = 'iOS Browser'
        } else if (isAndroidMobileBrowser.value) {
            platform = 'Android Browser'
        }
        platform = platform + ': apple btn ' + props.flagLog
        digitalApi.cardDownloadLog(
            props.cardNumber,
            platform,
            navigator.userAgent,
            'pass.com.harrods.rewards.' + props.cardNumber,
            getOatParam('AccessKey'),
            getOatParam('c')
        )
    }

    function getAppleCardFile() {
        const urlApple2 = refApple.value
        digitalApi
            .getAppleCardToken(
                props.customerId,
                getOatParam('AccessKey'),
                getOatParam('a')
            )
            .then(result => {
                const href = window.URL.createObjectURL(result)
                urlApple2.setAttribute('href', href)
                urlApple2.setAttribute('download', 'HarrodsDigitalCard.pkpass')
                urlApple2.click()
                logAppleButtonDownload()
            })
    }

    function downloadGoogle() {
        if (!googleButtonLoaded.value) {
            const googlePlatformScript = document.createElement('script')
            googlePlatformScript.setAttribute('src', 'https://apis.google.com/js/platform.js')
            document.head.appendChild(googlePlatformScript)
            googleButtonLoaded.value = true
        }
        return true
    }

    function getOatParam(key) {
        // Assumes use of vue-router, adjust as needed for your app
        // If using <script setup>, you can use useRoute() from vue-router
        // For now, fallback to window.location or similar if needed
        try {
            return route?.params?.oat?.[key]
        } catch {
            return undefined
        }
    }

    // EventBus registration
    onMounted(() => {
        if (eventBus) {
            eventBus.on('googleDownloadRef', googleCallback)
        }
    })
</script>

<style lang="scss" scoped>

.custom-text-thank-you-for-joining p {
  @media screen and (max-width: 991px) and (min-width: 0px) {
      font-size: 18px;
  }
}

.apple-icon {
    display: initial;
    width: 172px;
    height: 50px;
    object-fit: cover;

    &:hover,
    &:active,
    &:focus {
        cursor: pointer;
    }
}

.google-icon {
    width: 200px;
    height: 52px;

    &:hover,
    &:active,
    &:focus {
        color: $harrods-dark-gold-2;
        cursor: pointer;
    }
}

</style>
